import { environment } from "@org-avp/avp-avengers-ui-shared-environment";

export function createRedirectUri(path: string): string {
  const baseUrl = environment.NX_AVENGERS_BASE_URL.replaceAll(/\/$/g, "");
  path = path.replaceAll(/^\//g, "");
  return baseUrl + "/" + path;
}
